/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  /* Fix input doesn't focus in Brooklyn theme */
  InstantSearchStyle3.prototype.afterCloseInstantSearchStyle3 = function(isClose) {
    jQ('.mfp-close').trigger('click');
  }

  
    InstantSearchResult.prototype.render = function() {
		if (this.isFirstLoad) {
			// Render initial suggestion container and append it to the dom
			var suggestionHtml = this.compileTemplate();
			this.appendToSelector = 'body';
			this._applyFilterAutocompleteAppendElement();

			jQ(this.appendToSelector).append(suggestionHtml);
			this.$wrapper = jQ(this.selector.wrapper);
			this.$popoverElement = jQ(this.selector.popover);
			this.isFirstLoad = false;
		} else {
			// Show the suggestion popover and suggestion itself
			this.$instantSearchResult.show();
			this.$instantSearchResult.siblings().show();
			// Render suggestion blocks and items
			if (this.isLoading) {
				this._renderSuggestionLoading();
				this._renderWrapper();
			} else {
				this._renderWrapper();
				this._renderSuggestion();
			}

		}

        if(typeof(this.data) !== 'undefined' && this.data !== null && this.data.length > 0){
          var searchProducts = [];
          for(var i = 0; i < this.data.length; i++){
            if(this.data[i].key == 'products'){
              searchProducts = this.data[i].values;
              break;
            }
          }
          if(searchProducts.length > 0 && typeof(boostSdCustomConfig) !== 'undefined' && boostSdCustomConfig.customer.isB2B !== null){
            for(var i = 0; i < searchProducts.length; i++){
              var requestReg = formRequest(searchProducts[i].handle);
              requestReg.then((res_success) => {
                var res = JSON.parse(res_success);
                jQ('.boost-pfs-search-suggestion-item[data-id="'+ res.id +'"]').find('.boost-pfs-search-suggestion-product-price').html(res.price);
              }).catch((res_error) => {
                console.log(res_error)
              });
            }
          }
        }
	}

    function formRequest(value) {
      return new Promise((resolve, reject) => {
          var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
          xhr.open("GET", Shopify.routes.root + 'products/'+ value +'?view=boost-pfs-price');
          xhr.setRequestHeader('Content-Type', 'application/json');
          xhr.onload = () => resolve(xhr.responseText);
          xhr.onerror = () => reject(xhr.statusText);
          xhr.send();
      });
    }

})();